import template from './route_throw.html';
import controller from './route_throw.controller';
import './route_throw.scss';

let routeThrowComponent = {
  restrict: 'E',
  bindings: {
    printData: '='
  },
  template,
  controller
};

export default routeThrowComponent;

     


// WEBPACK FOOTER //
// ./client/app/components/route_throw/route_throw.component.js